/* Good Grain Bakery theme: mobile menu. The mobile menu and the price update on the product page need JavaScript; everything else works without it. */
(function () {
  var header = document.querySelector('[data-gg-header]');
  if (!header) return;
  var btn = header.querySelector('[data-gg-menu]');
  var panel = header.querySelector('#gg-mobile-nav');
  if (!btn || !panel) return;
  panel.hidden = false;
  function set(open) {
    header.setAttribute('data-open', open ? 'true' : 'false');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  btn.addEventListener('click', function () { set(header.getAttribute('data-open') !== 'true'); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  window.addEventListener('resize', function () { if (window.innerWidth > 900) set(false); });
})();

/* Product page: update the price when a different option is chosen. */
(function () {
  var select = document.querySelector('[data-gg-variant]');
  var price = document.querySelector('[data-gg-price]');
  if (!select || !price) return;
  select.addEventListener('change', function () {
    var opt = select.options[select.selectedIndex];
    if (opt && opt.getAttribute('data-price')) price.innerHTML = opt.getAttribute('data-price');
    var btn = document.querySelector('[data-gg-add]');
    if (btn) { btn.disabled = opt.disabled; }
    try { var u = new URL(window.location.href); u.searchParams.set('variant', select.value); window.history.replaceState({}, '', u.toString()); } catch (e) {}
  });
})();
